import { useMemo } from 'react'

import { useRequestTypes } from '@/api/models/requests/hooks/useRequestTypes'

const useFilteredRequestTypes = (allowedTypes: string[]) => {
  const { data: requestTypes } = useRequestTypes()

  return useMemo(() => {
    return requestTypes?.filter(type => allowedTypes.includes(type.alias)) ?? []
  }, [requestTypes, allowedTypes])
}

export { useFilteredRequestTypes }
